import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import '@angular/compiler';

import { AppModule } from './app/app.module';
import { environment } from './environment';
import { SentryService } from './app/core/services/sentry/sentry.service';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()],
  })
  .then((moduleRef) => {
    const sentryService = moduleRef.injector.get(SentryService);
    sentryService.initSentry();
  })
  .catch((err) => console.error(err));
